import axios from "axios";
import config from "../default_config";
import qs from "qs";

export const baseURL = config.baseURL;

export const Axios = axios.create({
  baseURL: baseURL
});

//请求拦截器 => 加token、序列化data
Axios.interceptors.request.use(
  config => {
    let token = window.localStorage.getItem("token");
    if (token) {
      config.headers.token = token;
    }

    if (config.headers["Content-Type"] === "multipart/form-data;") {
      return config;
    } else if (config.headers["Content-Type"] === "Application/json") {
      config.data = JSON.stringify(config.data);
    } else {
      if (typeof config.data === "object") {
        config.data = qs.stringify(config.data);
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//登录
export const login = async form => {
  return await Axios({
    method: "POST",
    url: "webLogin",
    data: {
      ...form
    }
  });
};

//修改密码
export const changePassword = async form => {
  return await Axios({
    method: "POST",
    url: "updatePasswd",
    data: {
      ...form
    }
  });
};

//修改昵称
export const changeNickname = async form => {
  return await Axios({
    method: "POST",
    url: "setNickname",
    data: {
      ...form
    }
  });
};

//获取锁厂列表
export const getFactoryList = async () => {
  return await Axios({
    method: "GET",
    url: "factory/all"
  });
};

//获取锁列表
export const getLockList = async paramObj => {
  return await Axios({
    method: "GET",
    url: "lock/search",
    params: {
      ...paramObj
    }
  });
};

//获取某个锁的信息
export const getLockBaseInfo = async paramObj => {
  return await Axios({
    method: "GET",
    url: "lock/key/listAll",
    params: {
      ...paramObj
    }
  });
};

//获取锁厂列表
export const getLockFactoryList = async paramObj => {
  return await Axios({
    method: "GET",
    url: "factory/search",
    params: {
      ...paramObj
    }
  });
};

//添加锁厂
export const addFactory = async form => {
  return await Axios({
    method: "POST",
    url: "factory/add",
    data: {
      ...form
    }
  });
};

//编辑锁厂
export const editFactory = async form => {
  return await Axios({
    method: "POST",
    url: "factory/edit",
    data: {
      ...form
    }
  });
};

//添加锁厂
export const delFactory = async form => {
  return await Axios({
    method: "POST",
    url: "factory/delete",
    data: {
      ...form
    }
  });
};

//添加产品
export const addProduct = async form => {
  return await Axios({
    method: "POST",
    url: "product/add",
    data: {
      ...form
    }
  });
};

//添加产品
export const delProduct = async id => {
  return await Axios({
    method: "POST",
    url: "product/delete",
    data: {
      id: id
    }
  });
};

//编辑产品
export const editProduct = async params => {
  return await Axios({
    method: "POST",
    url: "product/edit",
    data: {
      ...params
    }
  });
};

//重置密码
export const resetPassword = async params => {
  return await Axios({
    method: "POST",
    url: "factory/resetPasswd",
    data: {
      ...params
    }
  });
};

//编辑产品
export const productNameList = async params => {
  return await Axios({
    method: "GET",
    url: "product/all",
    params: {
      ...params
    }
  });
};

//根据产品id获取产品信息
export const productDetailById = async id => {
  return await Axios({
    method: "GET",
    url: "product/id",
    params: {
      id: id
    }
  });
};

//根据锁找用户
export const getLockUser = async paramObj => {
  return await Axios({
    method: "GET",
    url: "lock/listUser",
    params: {
      ...paramObj
    }
  });
};

//根据锁找用户
export const getLockUnuser = async paramObj => {
  return await Axios({
    method: "GET",
    url: "lock/key/listUnused",
    params: {
      ...paramObj
    }
  });
};

//报警记录
export const alertRecord = async paramObj => {
  return await Axios({
    method: "GET",
    url: "hist/alert/web",
    params: {
      ...paramObj
    }
  });
};

//获取产品列表
export const productList = async paramObj => {
  return await Axios({
    method: "GET",
    url: "product/search",
    params: {
      ...paramObj
    }
  });
};
//获取固件列表
export const firmwareList = async paramObj => {
  return await Axios({
    method: "GET",
    url: "/firmware/version/list",
    params: {
      ...paramObj
    }
  });
};
//添加/编辑固件
export const uploadFirmware = async form => {
  return await Axios({
    method: "POST",
    url: "firmware/uploadBin",
    data: form,
    headers: {
      "Content-Type": "multipart/form-data;"
    }
  });
};



// WEBPACK FOOTER //
// ./src/fetch/index.js